
angular.module("ainapp")
    .controller("inactiveAccountsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Inactive Accounts";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            $scope.Init = function () {

                $scope.Accounts = [];
                $scope.load = false;

                 $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetDeletedAccounts().then(function (response) {
                    if (response.data) {
                        $scope.Accounts = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                })



            }
            $scope.Init();




            $scope.SelectedDataForDelete = {};
            $scope.activateAcc = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deleteModal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.MakeAccountActive($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Success");
                        $scope.SelectedDataForDelete = {};
                         $scope.Init();
                    } else {
                        toastr.warning(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                });
            }




            }])
